export default __webpack_public_path__ + "static/media/clientTwo.bcf4793f.jpg";